import React, { useState } from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import { Box, CircularProgress, Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	container: {
		maxHeight: 868,
	},
	center: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	customToolbar: {
		padding: "16px",
		display: "flex",
		justifyContent: "space-between",
		width: "100%",
	},
	tableHeader: {
		background: theme.palette.grey[50],
		borderBottom: `1px solid ${theme.palette.grey.D400}`,
	},
}))

export default function BasicTable({
	columns,
	rows,
	isLoading,
	pageInfo,
	showPagination = false,
	sortInfo,
	onDataRequest,
	defaultSortBy,
	checkboxSelection,
	footerInfo,
	topBarInfo,
	totalCountText,
	userSelectedRows,
	showDownloadButton,
	showColumnsButton,
	toApplyHotKeys = false,
	showDuplicate = false,
	customClass = "basicTable",
	customCellPadding = "",
	elevation = 0,
}) {
	const theme = useTheme()
	const classes = useStyles()
	const [t] = useTranslation("global")

	const [page, setPage] = React.useState(0)
	const [rowsPerPage, setRowsPerPage] = React.useState(10)

	const handleChangePage = (event, newPage) => {
		setPage(newPage)
	}

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value)
		setPage(0)
	}

	function CustomToolbar() {
		return (
			<Box className={classes.customToolbar}>
				<div style={{ width: "50%" }}>
					<Typography variant="body2" style={{ ...theme.typography.subTitle2, color: theme.palette.grey.D100 }} component="span">
						{totalCountText}
					</Typography>
				</div>
			</Box>
		)
	}

	return (
		<Paper className={classes.root} elevation={elevation}>
			{CustomToolbar()}
			<TableContainer className={`${classes.container} ${customClass}`}>
				<Table stickyHeader aria-label="sticky table">
					<TableHead>
						<TableRow>
							{columns.map((column) => (
								<TableCell
									key={column.field}
									align={column?.headerAlign || "left"}
									className={classes.tableHeader}
									style={{ width: column.width }}
								>
									{column?.renderHeader ? column?.renderHeader() : column.headerName}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{isLoading ? (
							<>
								<TableRow>
									<TableCell colSpan={columns?.length}>
										<section className={classes.center}>
											<CircularProgress size={40} />
										</section>
									</TableCell>
								</TableRow>
							</>
						) : rows?.length ? (
							<>
								{rows?.map((row) => {
									return (
										<TableRow hover role="checkbox" tabIndex={-1} key={row?.id} selected={row?.selected}>
											{columns?.map((column) => {
												const value = row[column.field]
												const params = { row }
												return (
													<TableCell
														key={column?.field}
														align={column?.headerAlign}
														style={{ padding: customCellPadding ? customCellPadding : "1px 10px" }}
													>
														{column?.renderCell ? column?.renderCell(params) : value}
													</TableCell>
												)
											})}
										</TableRow>
									)
								})}
							</>
						) : (
							<>
								<TableRow>
									<TableCell colSpan={columns?.length}>
										<section className={classes.center}>
											<Typography>{t("concept.no_data")}</Typography>
										</section>
									</TableCell>
								</TableRow>
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			{showPagination && (
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={rows.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			)}
		</Paper>
	)
}
